import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './VacationRequests.css';
import api from '../services/api';
import { vacationService } from '../services/api';

const VacationRequests = ({ user }) => {
  const [requests, setRequests] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showApproved, setShowApproved] = useState(false);
  const [showRejected, setShowRejected] = useState(false);
  const [formData, setFormData] = useState({
    start_date: '',
    end_date: '',
    reason: ''
  });
  const [calMonth, setCalMonth] = useState(new Date().getMonth());
  const [calYear, setCalYear] = useState(new Date().getFullYear());

  const approvedRequestsList = requests.filter(r => r.status === 'approved');
  const daysInMonth = (y, m) => new Date(y, m + 1, 0).getDate();
  const getApprovedForDate = (y, m, d) => {
    const dateStr = `${y}-${String(m + 1).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
    return approvedRequestsList.filter(r => {
      if (user.role !== 'admin' && r.user_id !== user.id) return false;
      return r.start_date <= dateStr && r.end_date >= dateStr;
    });
  };


  // Safety check for user
  useEffect(() => {
    if (user) {
      loadRequests();
    }
  }, [user]);
  const location = useLocation();
  // Open modal automatically if ?new=1 is present
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('new') === '1') {
      setShowForm(true);
    }
  }, [location.search]);


  if (!user) {
    return (
      <div className="vacation-container">
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Načítavam používateľské údaje...</p>
        </div>
      </div>
    );
  }

  const loadRequests = async () => {
    try {
      setLoading(true);
      const data = await vacationService.getAll();
      setRequests(data);
    } catch (error) {
      console.error('Error loading requests:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Require start_date before end_date
    if (!formData.start_date) {
      alert('Najprv zadajte dátum OD kedy chcete voľno.');
      return;
    }

    // Disallow past dates (only today or future)
    const today = new Date(); today.setHours(0,0,0,0);
    const startDate = new Date(formData.start_date); startDate.setHours(0,0,0,0);
    if (startDate < today) {
      alert('Začiatok voľna nemôže byť v minulosti. Zvoľte dnešný alebo budúci dátum.');
      return;
    }

    // If end_date provided, must be >= start_date
    if (formData.end_date) {
      const endDate = new Date(formData.end_date); endDate.setHours(0,0,0,0);
      if (endDate < startDate) {
        alert('Konečný dátum nemôže byť skôr ako začiatočný dátum.');
        return;
      }
    }

    // Validate reason length with hard limit
    if (formData.reason && formData.reason.length > 255) {
      alert('Text je príliš dlhý. Upravte dôvod (max 255 znakov).');
      return;
    }
    
    try {
      await vacationService.create({
        start_date: formData.start_date,
        end_date: formData.end_date,
        reason: formData.reason
      });
      
      loadRequests(); // Reload requests
      setShowForm(false);
      setFormData({
        start_date: '',
        end_date: '',
        reason: ''
      });
      alert('Žiadosť o voľno bola úspešne odoslaná!');
    } catch (error) {
      console.error('Error submitting request:', error);
      if (error.response?.data?.error) {
        alert(error.response.data.error);
      } else {
        alert('Nastala chyba pri odosielaní žiadosti');
      }
    }
  };

  const handleApprove = async (requestId) => {
    try {
      const response = await api.put(`/vacation-requests/${requestId}`, {
        status: 'approved',
        notes: 'Schválené administrátorom'
      }, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      
      if (response.status === 200) {
        loadRequests(); // Reload requests
        alert('Žiadosť bola schválená!');
      } else {
        throw new Error('Failed to approve request');
      }
    } catch (error) {
      console.error('Error approving request:', error);
      alert('Nastala chyba pri schvaľovaní žiadosti');
    }
  };

  const handleReject = async (requestId, reason) => {
    try {
      const response = await api.put(`/vacation-requests/${requestId}`, {
        status: 'rejected',
        notes: reason
      }, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      
      if (response.status === 200) {
        loadRequests(); // Reload requests
        alert('Žiadosť bola zamietnutá!');
      } else {
        throw new Error('Failed to reject request');
      }
    } catch (error) {
      console.error('Error rejecting request:', error);
      alert('Nastala chyba pri zamietaní žiadosti');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Ste si istí, že chcete vymazať túto žiadosť? Táto akcia sa nedá vrátiť späť.')) {
      return;
    }

    try {
      await vacationService.delete(id);
      loadRequests(); // Reload requests
      alert('Žiadosť bola úspešne vymazaná!');
    } catch (error) {
      console.error('Error deleting request:', error);
      if (error.response?.data?.error) {
        alert(`Chyba: ${error.response.data.error}`);
      } else {
        alert('Nastala chyba pri vymazávaní žiadosti');
      }
    }
  };

  const handleDeleteAllHistory = async () => {
    console.log('🗑️ handleDeleteAllHistory called');
    console.log('🗑️ All requests:', requests);
    const approvedRequests = requests.filter(req => req.status === 'approved');
    const rejectedRequests = requests.filter(req => req.status === 'rejected');
    console.log('🗑️ Approved requests:', approvedRequests);
    console.log('🗑️ Rejected requests:', rejectedRequests);
    const totalHistoryRequests = approvedRequests.length + rejectedRequests.length;
    console.log('🗑️ Total history requests:', totalHistoryRequests);

    if (totalHistoryRequests === 0) {
      console.log('🗑️ No history requests to delete, showing alert');
      alert('Žiadne schválené alebo zamietnuté žiadosti na vymazanie.');
      console.log('🗑️ Alert should have been shown');
      return;
    }

    if (!window.confirm(`Ste si istí, že chcete vymazať všetky schválené a zamietnuté žiadosti (${totalHistoryRequests} žiadostí)? Táto akcia sa nedá vrátiť späť.`)) {
      return;
    }

    try {
      let deletedCount = 0;
      let errorCount = 0;

      // Delete all approved requests
      for (const request of approvedRequests) {
        try {
          await vacationService.delete(request.id);
          deletedCount++;
        } catch (error) {
          console.error(`Error deleting approved request ${request.id}:`, error);
          errorCount++;
        }
      }

      // Delete all rejected requests
      for (const request of rejectedRequests) {
        try {
          await vacationService.delete(request.id);
          deletedCount++;
        } catch (error) {
          console.error(`Error deleting rejected request ${request.id}:`, error);
          errorCount++;
        }
      }

      loadRequests(); // Reload requests
      
      if (errorCount === 0) {
        alert(`Všetky žiadosti z histórie boli úspešne vymazané! (${deletedCount} žiadostí)`);
      } else {
        alert(`Vymazané: ${deletedCount} žiadostí. Chyby: ${errorCount} žiadostí.`);
      }
    } catch (error) {
      console.error('Error deleting history:', error);
      alert('Nastala chyba pri vymazávaní histórie žiadostí');
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const getStatusBadge = (status) => {
    const badges = {
      pending: { text: 'Čaká na schválenie', class: 'pending' },
      approved: { text: 'Schválené', class: 'approved' },
      rejected: { text: 'Zamietnuté', class: 'rejected' }
    };
    return badges[status] || badges.pending;
  };

  const getStatusIcon = (status) => {
    const icons = {
      pending: '⏳',
      approved: '✅',
      rejected: '❌'
    };
    return icons[status] || '⏳';
  };

  if (loading) {
    return (
      <div className="vacation-container">
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Načítavam žiadosti...</p>
        </div>
      </div>
    );
  }

  // Filter requests by status
  const pendingRequests = requests.filter(req => req.status === 'pending');
  const approvedRequests = requests.filter(req => req.status === 'approved'); // history panel
  const rejectedRequests = requests.filter(req => req.status === 'rejected');

  const renderRequestCard = (request, showActions = false) => {
    const badge = getStatusBadge(request.status);
    return (
      <div key={request.id} className="request-card">
        <div className="request-header">
          <div className="request-dates">
            <h3>
              📅 {new Date(request.start_date).toLocaleDateString('sk-SK')} - {new Date(request.end_date).toLocaleDateString('sk-SK')}
            </h3>
            <p className="request-duration">
              ({Math.ceil((new Date(request.end_date) - new Date(request.start_date)) / (1000 * 60 * 60 * 24)) + 1} dní)
            </p>
          </div>
          <div className={`status-badge ${badge.class}`}>
            {getStatusIcon(request.status)} {badge.text}
          </div>
        </div>
        
        <div className="request-content">
          {request.reason && (
            <div className="request-reason">
              <strong>Dôvod:</strong> {request.reason}
            </div>
          )}
          
          <div className="request-meta">
            {user.role === 'admin' && (
              <span>
                <span style={{fontWeight: 600}}>👤 Žiadateľ:</span> {request.full_name}
              </span>
            )}
            <span>
              <span style={{fontWeight: 600}}>📝 Vytvorené:</span> {new Date(request.created_at).toLocaleDateString('sk-SK')}
            </span>
            {request.approved_at && (
              <span>
                <span style={{fontWeight: 600}}>📅 Spracované:</span> {new Date(request.approved_at).toLocaleDateString('sk-SK')}
              </span>
            )}
            {request.approved_by_name && (
              <span>
                <span style={{fontWeight: 600}}>👔 Spracoval:</span> {request.approved_by_name}
              </span>
            )}
          </div>
          
          {request.admin_comment && (
            <div className="admin-comment">
              <strong>💬 Komentár administrátora</strong>
              <div>{request.admin_comment}</div>
            </div>
          )}
        </div>

        {/* Admin actions for pending requests */}
        {request.status === 'pending' && user.role === 'admin' && (
          <div className="admin-actions">
            <button 
              className="approve-btn" 
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleApprove(request.id);
              }}
            >
              ✅ Schváliť
            </button>
            <button 
              className="reject-btn" 
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                const reason = prompt('Zadajte dôvod zamietnutia:');
                if (reason) {
                  handleReject(request.id, reason);
                }
              }}
            >
              ❌ Zamietnuť
            </button>
          </div>
        )}

        {/* User can delete their own requests (any status) */}
        {request.user_id === user.id && user.role !== 'admin' && (
          <div className="admin-actions">
            <button 
              className="delete-btn" 
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                if (window.confirm('Naozaj chcete vymazať túto žiadosť?')) {
                  handleDelete(request.id);
                }
              }}
            >
              🗑️ Vymazať
            </button>
          </div>
        )}


      </div>
    );
  };


  return (
    <div className="vacation-container">


      <div className="vacation-header">
        <h1 className="vacation-title">🏖️ Žiadosti o voľno</h1>
        <button 
          className="add-request-btn"
          onClick={() => setShowForm(true)}
        >
          ➕ Nová žiadosť
        </button>
      </div>

      <div className="vacation-columns">
        {/* Left Column - Pending Requests */}
        <div className="pending-column">
          <div className="column-header">
            <h2>⏳ Čaká na schválenie ({pendingRequests.length})</h2>
          </div>
          <div className="requests-list">
            {pendingRequests.length === 0 ? (
              <div className="no-requests">
                <p>📝 Žiadne čakajúce žiadosti</p>
              </div>
            ) : (
              pendingRequests.map(request => renderRequestCard(request, true))
            )}
          </div>
          <div className="column-header vacation-calendar-header" style={{ alignItems:'center', marginTop: '1rem' }}>
            <h2>📅 Kalendár schválených dovoleniek</h2>
            <div className="nav-row" style={{ display:'flex', gap:'8px', alignItems:'center', justifyContent:'center' }}>
              <button className="nav-btn" onClick={() => { const nm = calMonth===0?11:calMonth-1; const ny = calMonth===0?calYear-1:calYear; setCalMonth(nm); setCalYear(ny); }}>←</button>
              <div className="current-month">{new Date(calYear, calMonth).toLocaleString('sk-SK', { month:'long', year:'numeric' })}</div>
              <button className="nav-btn" onClick={() => { const nm = calMonth===11?0:calMonth+1; const ny = calMonth===11?calYear+1:calYear; setCalMonth(nm); setCalYear(ny); }}>→</button>
            </div>
          </div>
          <div className="vacation-calendar" style={{margin: '0 auto 2rem auto'}}>
            <div className="unified-calendar-grid" style={{margin: '0 auto'}} >
              {["Po","Ut","St","Št","Pi","So","Ne"].map((w,i)=>(<div key={i} className="weekday-cell">{w}</div>))}
              {(() => {
                const firstDay = new Date(calYear, calMonth, 1);
                const startOffset = (firstDay.getDay()+6)%7; // Monday=0
                const totalDays = daysInMonth(calYear, calMonth);
                const cells = [];
                // leading blanks
                for (let i=0;i<startOffset;i++) cells.push(<div key={'e'+i} className="vacation-calendar-day empty"/>);
                // real days
                for (let d=1; d<=totalDays; d++) {
                  const matches = getApprovedForDate(calYear, calMonth, d);
                  const isToday = (new Date(calYear, calMonth, d)).toDateString() === (new Date()).toDateString();
                  cells.push(
                    <div key={'d'+d} className={`vacation-calendar-day ${isToday?'today':''}`} style={{ background: matches.length ? 'repeating-linear-gradient(45deg, #ffe8cc, #ffe8cc 6px, #ffd8a8 6px, #ffd8a8 12px)' : 'white' }} title={matches.map(m=>`👤 ${(m.full_name||m.username)||m.user_id} • požiadal: ${new Date(m.created_at).toLocaleDateString('sk-SK')} • schválil: ${m.approved_by_name||'—'}`).join('\n')}>
                      <div className="day-number">{d}</div>
                      {matches.length>0 && (
                        <div className="vacation-count">{matches.length} dov.</div>
                      )}
                    </div>
                  );
                }
                // ensure constant 6-week grid (42 cells) for consistent height/centering
                const used = startOffset + totalDays;
                const totalCells = 42; // 6 rows * 7 days
                for (let i = used; i < totalCells; i++) {
                  cells.push(<div key={'t'+i} className="vacation-calendar-day empty"/>);
                }
                return cells;
              })()}
            </div>
          </div>

        </div>



        {/* Right Column - History */}
        <div className="history-column">
          <div className="column-header">
            <div className="history-header-row">
              <h2>📋 História</h2>
              {user.role === 'admin' && (
                <button 
                  className="delete-btn history-delete-btn" 
                  onClick={(e) => {
                    console.log('🔥 Reset button clicked!');
                    e.preventDefault();
                    e.stopPropagation();
                    handleDeleteAllHistory();
                  }}
                >
                  🗑️ Reset
                </button>
              )}
            </div>
          </div>
          
          {/* Approved Requests Dropdown */}
          <div className="history-section">
            <div 
              className="history-toggle approved"
              onClick={() => setShowApproved(!showApproved)}
            >
              <span>✅ Schválené žiadosti ({approvedRequests.length})</span>
              <span className={`arrow ${showApproved ? 'up' : 'down'}`}>▼</span>
            </div>
            {showApproved && (
              <div className="history-content">
                {approvedRequests.length === 0 ? (
                  <div className="no-requests">
                    <p>Žiadne schválené žiadosti</p>
                  </div>
                ) : (
                  approvedRequests.map(request => renderRequestCard(request, false))
                )}
              </div>
            )}
          </div>

          {/* Rejected Requests Dropdown */}
          <div className="history-section">
            <div 
              className="history-toggle rejected"
              onClick={() => setShowRejected(!showRejected)}
            >
              <span>❌ Zamietnuté žiadosti ({rejectedRequests.length})</span>
              <span className={`arrow ${showRejected ? 'up' : 'down'}`}>▼</span>
            </div>
            {showRejected && (
              <div className="history-content">
                {rejectedRequests.length === 0 ? (
                  <div className="no-requests">
                    <p>Žiadne zamietnuté žiadosti</p>
                  </div>
                ) : (
                  rejectedRequests.map(request => renderRequestCard(request, false))
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      {showForm && (
        <div className="modal-overlay">
          <div className="modal">
            <div className="modal-header">
              <h2>➕ Nová žiadosť o voľno</h2>
              <button 
                className="close-btn"
                onClick={() => setShowForm(false)}
              >
                ✕
              </button>
            </div>
            
            <form onSubmit={handleSubmit} className="vacation-form">
              <div className="form-group">
                <label htmlFor="start_date" className="form-label">
                  📅 Od dátumu
                </label>
                <input
                  type="date"
                  id="start_date"
                  name="start_date"
                  value={formData.start_date}
                  onChange={handleInputChange}
                  className="form-input"
                  min={new Date().toISOString().split('T')[0]}
                  max={formData.end_date}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="end_date" className="form-label">
                  📅 Do dátumu
                </label>
                <input
                  type="date"
                  id="end_date"
                  name="end_date"
                  value={formData.end_date}
                  onChange={handleInputChange}
                  className="form-input"
                  min={formData.start_date}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="reason" className="form-label">
                  📝 Dôvod (voliteľné)
                </label>
                <textarea
                  id="reason"
                  name="reason"
                  value={formData.reason}
                  onChange={handleInputChange}
                  className="form-textarea"
                  placeholder="Uveďte dôvod žiadosti o voľno..."
                  rows="3"
                  maxLength="255"
                />
                <div className="character-counter" style={{ textAlign: 'right', fontSize: '12px', color: formData.reason.length > 255 ? '#dc3545' : '#6c757d' }}>
                  {formData.reason.length} / 255 znakov
                </div>
              </div>

              <div className="form-actions">
                <button type="button" className="cancel-btn" onClick={() => setShowForm(false)}>
                  Zrušiť
                </button>
                <button type="submit" className="submit-btn">
                  📤 Odoslať žiadosť
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default VacationRequests;